import 'antd/es/button/style/css';
import 'antd/es/dropdown/style/css';
import 'antd/es/menu/style/css';
import 'antd/es/table/style/css';
import 'antd/es/tabs/style/css';
import './index.less';
